import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import { Chip, Typography, Box } from "@mui/material";
import { formatDate } from "../../../utils/datetime";
import { useTranslation } from "react-i18next";
import AwardIcon from "../../Svgs/AwardIcon/AwardIcon";

const getDate = date => {
  const dateStr = formatDate(date);
  if (dateStr === formatDate(new Date())) {
    return "Today";
  }
  return dateStr;
};

const useStyles = makeStyles(theme => ({
  badge: {
    position: "absolute",
    top: theme.spacing(1),
    left: 0
  }
}));

const AwardsList = ({ achievements }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  return achievements
    ? achievements.map(
        achievement =>
          achievement.award && (
            <Box
              display="flex"
              alignItems="center"
              mb={2}
              position="relative"
              pl={2}
            >
              <AwardIcon
                awardType={achievement.award.type}
                awardColor={achievement.award.color}
                customIcon={achievement.award.customIcon}
                awardTitle={achievement.award.title}
              />

              <Box ml={3}>
                <Typography variant="h6">{achievement.award.name}</Typography>
                <Typography variant="body2" color="textSecondary">
                  {`${t("awardWidget.awarded")} ${getDate(achievement.date)}`}
                </Typography>
              </Box>
              {achievement.isNew && (
                <Chip
                  className={classes.badge}
                  color="primary"
                  size="small"
                  label={
                    <Typography variant="overline">{`${t(
                      "awardWidget.new"
                    )}`}</Typography>
                  }
                />
              )}
            </Box>
          )
      )
    : null;
};

export default AwardsList;
